import React from 'react';
import { Link } from 'react-router-dom';
import './footer.css';
import line16 from '../../assets/line-16.svg';
const imgStyle={
      maxWidth: '100%',
      maxHeight: '100%',
 };
function Footer() {
      return (
            <footer className="footer_nova">
                  <div className='footer_section1'>
                        <div className='wrap_footer_section1'>
                              <p className="plus-de-pouvoir-pour_nova">
                                    Plus De Pouvoir Pour Votre Entreprise. Prêt
                                    À En Profiter ?
                              </p>
                              <div className='wrap_btns'>
                                    <div className="overlap-6_nova">
                                          <Link to="/gallery" className="text-wrapper-15_nv">
                                                Commencer
                                          </Link>
                                    </div>
                                    <div className="overlap-7_nova">
                                          <Link to="/contact-us" className="text-wrapper-16_nv">
                                                Contacter
                                          </Link>
                                    </div>
                              </div>
                        </div>
                        <img
                              className="line_footer_nova"
                              alt="Line"
                              src={line16}
                        />
                  </div>
                  <div className='footer_section2'>
                        <div className="footer-content_nova first_footer_div">
                              <div className='aboutUsfooter'>
                                    <div id="moncercle" > <img src="LOGO_NOVAZON.png" alt="NOVAZON" style={imgStyle}/>
                                    </div> 
                                          <h4 className="novazon-relay"> Novazon Relay </h4>
                              </div>
                              
                              <p className="lorem-ipsum-dolor-si">
                              Rejoignez notre communauté dès aujourd&#39;hui !
                              </p>
                              <div className="icons">
                                    <Link to="https://web.facebook.com/people/Novazon/61550709103277/" target="_blank">
                                          <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="36"
                                                height="36"
                                                viewBox="0 0 36 36"
                                                fill="none"
                                          >
                                                <path
                                                      d="M19.7735 30.7811V18.952H23.8545L24.4611 14.3205H19.7735V11.3704C19.7735 10.034 20.1543 9.11892 22.1158 9.11892H24.6014V4.98969C23.392 4.86296 22.1764 4.80177 20.9602 4.8064C17.3529 4.8064 14.8762 6.95977 14.8762 10.9129V14.3119H10.8218V18.9433H14.8851V30.7811H19.7735Z"
                                                      fill="white"
                                                />
                                          </svg>
                                    </Link>
                                    <Link to="https://www.tiktok.com/@novazon_officiel?_t=8hUlSp8r6jg&_r=1" target="_blank">
                                          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="32" height="32" viewBox="0,0,256,256" fill="#FFFFFF">
                                                <g fill="#ffffff" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" mixblendmode="normal"><g transform="scale(5.12,5.12)"><path d="M41,4h-32c-2.757,0 -5,2.243 -5,5v32c0,2.757 2.243,5 5,5h32c2.757,0 5,-2.243 5,-5v-32c0,-2.757 -2.243,-5 -5,-5zM37.006,22.323c-0.227,0.021 -0.457,0.035 -0.69,0.035c-2.623,0 -4.928,-1.349 -6.269,-3.388c0,5.349 0,11.435 0,11.537c0,4.709 -3.818,8.527 -8.527,8.527c-4.709,0 -8.527,-3.818 -8.527,-8.527c0,-4.709 3.818,-8.527 8.527,-8.527c0.178,0 0.352,0.016 0.527,0.027v4.202c-0.175,-0.021 -0.347,-0.053 -0.527,-0.053c-2.404,0 -4.352,1.948 -4.352,4.352c0,2.404 1.948,4.352 4.352,4.352c2.404,0 4.527,-1.894 4.527,-4.298c0,-0.095 0.042,-19.594 0.042,-19.594h4.016c0.378,3.591 3.277,6.425 6.901,6.685z"></path></g></g>
                                          </svg>
                                    </Link>
                                    <Link to="https://www.linkedin.com/company/n-o-v-a-z-o-n" target="_blank">
                                          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="32" height="32" viewBox="0 0 50 50"
                                          fill="#FFFFFF">
                                          <path d="M41,4H9C6.24,4,4,6.24,4,9v32c0,2.76,2.24,5,5,5h32c2.76,0,5-2.24,5-5V9C46,6.24,43.76,4,41,4z M17,20v19h-6V20H17z M11,14.47c0-1.4,1.2-2.47,3-2.47s2.93,1.07,3,2.47c0,1.4-1.12,2.53-3,2.53C12.2,17,11,15.87,11,14.47z M39,39h-6c0,0,0-9.26,0-10 c0-2-1-4-3.5-4.04h-0.08C27,24.96,26,27.02,26,29c0,0.91,0,10,0,10h-6V20h6v2.56c0,0,1.93-2.56,5.81-2.56 c3.97,0,7.19,2.73,7.19,8.26V39z"></path>
                                          </svg>
                                    </Link>
                                    <Link to="https://instagram.com/hello.novazon?igshid=OGQ5ZDc2ODk2ZA==" target="_blank">
                                          <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="36"
                                                height="36"
                                                viewBox="0 0 36 36"
                                                fill="none"
                                          >
                                                <g clipPath="url(#clip0_10_1046)">
                                                      <path
                                                            d="M17.7936 10.8581C13.8673 10.8581 10.6986 13.9567 10.6986 17.796C10.6986 21.6354 13.8673 24.7339 17.7936 24.7339C21.7199 24.7339 24.8886 21.6354 24.8886 17.796C24.8886 13.9567 21.7199 10.8581 17.7936 10.8581ZM17.7936 22.3052C15.2545 22.3052 13.1823 20.2789 13.1823 17.796C13.1823 15.3131 15.2545 13.2869 17.7936 13.2869C20.3327 13.2869 22.4048 15.3131 22.4048 17.796C22.4048 20.2789 20.3327 22.3052 17.7936 22.3052ZM25.1791 8.95707C24.2624 8.95707 23.5221 9.68096 23.5221 10.5774C23.5221 11.4738 24.2624 12.1977 25.1791 12.1977C26.0959 12.1977 26.8361 11.4772 26.8361 10.5774C26.8364 10.3645 26.7937 10.1537 26.7106 9.95699C26.6274 9.76029 26.5053 9.58156 26.3514 9.43105C26.1975 9.28053 26.0147 9.16119 25.8136 9.07986C25.6124 8.99853 25.3968 8.9568 25.1791 8.95707ZM31.6238 17.796C31.6238 15.9288 31.6411 14.0785 31.5338 12.2146C31.4266 10.0497 30.9216 8.12831 29.3026 6.54521C27.6802 4.95872 25.7188 4.46823 23.5048 4.36337C21.5953 4.25851 19.7031 4.27542 17.797 4.27542C15.8875 4.27542 13.9953 4.25851 12.0892 4.36337C9.87527 4.46823 7.91039 4.96211 6.29145 6.54521C4.66904 8.13169 4.16745 10.0497 4.06021 12.2146C3.95297 14.0818 3.97027 15.9322 3.97027 17.796C3.97027 19.6599 3.95297 21.5136 4.06021 23.3775C4.16745 25.5424 4.6725 27.4638 6.29145 29.0469C7.91385 30.6334 9.87527 31.1238 12.0892 31.2287C13.9987 31.3336 15.891 31.3167 17.797 31.3167C19.7066 31.3167 21.5988 31.3336 23.5048 31.2287C25.7188 31.1238 27.6837 30.63 29.3026 29.0469C30.925 27.4604 31.4266 25.5424 31.5338 23.3775C31.6445 21.5136 31.6238 19.6633 31.6238 17.796ZM28.5796 25.7724C28.3271 26.3881 28.0227 26.8481 27.5349 27.3217C27.0472 27.7987 26.5802 28.0963 25.9506 28.3433C24.131 29.0503 19.8103 28.8913 17.7936 28.8913C15.7768 28.8913 11.4527 29.0503 9.63312 28.3467C9.00353 28.0997 8.53306 27.802 8.04876 27.3251C7.561 26.8481 7.25659 26.3915 7.00406 25.7758C6.28453 23.9931 6.44711 19.7681 6.44711 17.796C6.44711 15.8239 6.28453 11.5956 7.00406 9.81627C7.25659 9.20062 7.561 8.74057 8.04876 8.267C8.53652 7.79342 9.00353 7.49236 9.63312 7.24542C11.4527 6.54182 15.7768 6.70081 17.7936 6.70081C19.8103 6.70081 24.1344 6.54182 25.954 7.24542C26.5836 7.49236 27.0541 7.79004 27.5384 8.267C28.0261 8.74396 28.3305 9.20062 28.5831 9.81627C29.3026 11.5956 29.14 15.8239 29.14 17.796C29.14 19.7681 29.3026 23.9931 28.5796 25.7724Z"
                                                            fill="white"
                                                      />
                                                </g>
                                                <defs>
                                                      <clipPath id="clip0_10_1046">
                                                            <rect
                                                                  width="35.4231"
                                                                  height="34.6388"
                                                                  fill="white"
                                                                  transform="translate(0.0820312 0.476562)"
                                                            />
                                                      </clipPath>
                                                </defs>
                                          </svg>
                                    </Link>
                              </div>
                        </div>
                        
                        <div className="footer-content_nova">
                              <h4 className="poppins-bold-white-16px">Liens</h4>
                              <ul>
                                    <li>
                                          <Link
                                                to="/contact-us"
                                                className="poppins-medium-white-12px"
                                          >
                                                contactez-nous 
                                          </Link>
                                    </li>
                                    <li>
                                          <Link
                                                to="/gallery"
                                                className="poppins-medium-white-12px"
                                          >
                                                Découvrir 
                                          </Link>
                                    </li>
                              </ul>
                        </div>
                        <div className="footer-content_nova">
                              <h4 className="poppins-bold-white-16px">Informations</h4>
                              <ul>
                                    <li>
                                          <Link
                                                to="/faqs"
                                                className="poppins-medium-white-12px"
                                          >
                                                FAQs
                                          </Link>
                                    </li>
                                    {/* <li>
                                          <Link
                                                to="#"
                                                className="poppins-medium-white-12px"
                                          >
                                                Termes
                                          </Link>
                                    </li> */}
                              </ul>
                        </div>
                  </div>
                  <div className='footer_section3'>
                  
                        <div className='copyrigths'>
                              <p>Réalisé par  <Link to="https://www.aavon-it.com" target="_blank" className='madeby'>AAVON-IT</Link>, &nbsp; ©2023 NOVAZON RELAY - Tous droits réservés. </p>
                        </div>
                  </div>
            </footer>
      );
}

export default Footer;
